const y = ({
  mapId: i,
  state: l,
  layerGroupId: o,
  subLayerId: n
}) => {
  var C, t, e, f, g, r, u, s, x, a, p, v, B, F, b, c, m;
  return n && o ? (u = (r = (g = (f = (e = (t = (C = l.maps) == null ? void 0 : C[i]) == null ? void 0 : t.layerGroupConfig) == null ? void 0 : e[o]) == null ? void 0 : f.subLayerConfig) == null ? void 0 : g[n]) == null ? void 0 : r.visualFilter) == null ? void 0 : u.poiCalloutBoxConfig : ((v = (p = (a = (x = (s = l.maps) == null ? void 0 : s[i]) == null ? void 0 : x.layerGroupConfig) == null ? void 0 : a[o]) == null ? void 0 : p.visualFilter) == null ? void 0 : v.poiCalloutBoxConfig) || ((m = (c = (b = (F = (B = l.maps) == null ? void 0 : B[i]) == null ? void 0 : F.layerGroupConfig) == null ? void 0 : b[o]) == null ? void 0 : c.visualFilter) == null ? void 0 : m.textboxStyleConfig);
};
export {
  y as getPOICalloutBoxConfig
};
//# sourceMappingURL=index.es28.js.map
